import { utcOffset } from "../../utils/time";
import timezoneMapper from "../mappers/timezone";
import updateTimezone from "./updateTimezone";

export default () => (dispatch, getState) => {
  const { timezone } = timezoneMapper(getState());

  if (typeof timezone !== "number") {
    return dispatch(
      updateTimezone({
        timezone: utcOffset()
      })
    );
  }

  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/store/epics/setSystemTimezone.js